import { AxiosError } from 'axios';

export const AML_SCREENING_STATUS = {
  NOT_SCREENED: 'NOT_SCREENED',
  SCREENED: 'SCREENED',
  CREDENTIALS_NOT_CONFIGURED: 'CREDENTIALS_NOT_CONFIGURED',
};

export const AML_SCREENING_ERROR_CODES = {
  CREDENTIALS_NOT_CONFIGURED: 'CREDENTIALS_NOT_CONFIGURED',
  SCREENING_FAILED: 'SCREENING_FAILED',
  PROFILE_NOT_FOUND: 'PROFILE_NOT_FOUND',
  INTERNAL: 'INTERNAL_ERROR',
};

export const mapAmlScreeningError = (error, labels) => {
  const responseData = error instanceof AxiosError ? error.response?.data : undefined;
  const code = responseData?.code;
  const apiError = responseData?.error?.trim();
  if (apiError && apiError.length <= 180 && !apiError.includes('{')) {
    return apiError;
  }
  switch (code) {
    case AML_SCREENING_ERROR_CODES.CREDENTIALS_NOT_CONFIGURED:
      return labels.credentialsNotConfigured;
    case AML_SCREENING_ERROR_CODES.SCREENING_FAILED:
      return labels.screeningFailed;
    case AML_SCREENING_ERROR_CODES.INTERNAL:
      return labels.generic;
    default:
      break;
  }

  const raw = responseData?.error || responseData?.message || error?.message || String(error);
  if (raw.length > 180 || raw.includes('{')) {
    return labels.generic;
  }

  return raw || labels.generic;
};
